export default "__VITE_ASSET__Ch5jiTQR__"